<template>
  <div>
    <div
      class="Card-root Card--radius--all Card--shadow--keyline Box-root Box-hideIfEmpty Box-background--white"
      style="margin-bottom: 8px"
    ></div>
    <div
      class="db-CardlessUIPpanelsWrapper db-CustomerDetailPpanels"
      v-if="finalOrder"
    >
      <div style="display: flex; max-width: 1380px">
        <div
          class="db-TwoColumnLayout--leftColumn"
          style="min-width: 250px; max-width: 520px; flex: 0 0 25%"
        >
          <div style="align-self: flex-start; position: sticky">
            <div class="Box-root Padding-bottom--48">
              <div class="Box-root Padding-bottom--20">
                <div
                  class="Card-root Card--radius--all Section Box-root Box-background--white"
                  style="overflow: visible"
                >
                  <div
                    class="Box-root Padding-top--20 Padding-bottom--12 Padding-horizontal--0"
                  >
                    <div
                      class="Box-root Flex-flex Flex-alignItems--baseline Flex-direction--row"
                      style="position: relative; min-width: 0px"
                    >
                      <div
                        class="TextAligner Box-root"
                        style="
                          line-height: 32px;
                          font-size: 28px;
                          flex: 0 0 auto;
                        "
                      ></div>
                      <div style="min-height: 50px; width: 100%">
                        <!-- <div
                          class="
                            Box-root
                            Padding-top--16
                            Flex-flex
                            Flex-direction--row
                          "
                        >
                          <v-text-field
                            dense
                            v-on:keyup.enter="searchOrder()"
                            label="Sample Id"
                            style="width: 90%; margin: 0px"
                            v-model="SampleId"
                            filled
                          ></v-text-field>
                        </div> -->
                        <div
                          style="width: 100%"
                          v-if="order ? order.patient : false"
                        >
                          <v-card
                            elevation="0"
                            style="border: 2px solid #bbdefb"
                          >
                            <v-card-title>
                              <div>
                                {{ order.patient.firstName }}
                                {{ order.patient.fatherName }}
                                {{ order.patient.grandFatherName }}
                              </div>
                            </v-card-title>
                            <v-card-subtitle>
                              <div>
                                MRN:
                                <!-- {{ order }} -->
                                <v-chip
                                  style="height: 20px; margin-left: 5px"
                                  v-for="(
                                    patientMRN, index
                                  ) in order.PatientMRNs"
                                  :key="index"
                                  >{{ patientMRN.mrn }}</v-chip
                                >
                              </div>
                            </v-card-subtitle>
                            <div style="padding-left: 15px">
                              <div style="display: flex">
                                <span class="font-weight-bold mr-2 mb-1"
                                  >Birth Date:</span
                                >
                                {{
                                  order.patient.birthDate
                                    | moment("from", "now", true)
                                }}
                              </div>
                              <div
                                style="display: flex"
                                v-if="order.patient.gender"
                              >
                                <span class="font-weight-bold mr-2 mb-1"
                                  >Gender:</span
                                >
                                {{ order.patient.gender.title }}
                              </div>
                              <div
                                style="display: flex"
                                v-if="order.patient.maritalStatus"
                              >
                                <span class="font-weight-bold mr-2 mb-1"
                                  >Martial Status:</span
                                >
                                {{ order.patient.maritalStatus.title }}
                              </div>
                              <div
                                style="display: flex"
                                v-if="order.patient.vitalStatus"
                              >
                                <span class="font-weight-bold mr-2 mb-1"
                                  >Vital Status:</span
                                >
                                {{ order.patient.vitalStatus.title }}
                              </div>
                            </div>
                          </v-card>

                          <div class="flex">
                            <span></span>
                          </div>
                        </div>
                        <div style="margin-top: 5px; width: 100%" v-if="order">
                          <v-card
                            elevation="0"
                            style="
                              border: 2px solid #bbdefb;
                              padding-top: 10px;
                              margin-top: 10px;
                              padding-bottom: 10px;
                            "
                          >
                            <div
                              class="ml-4"
                              style="display: flex"
                              v-if="order.institutionSite"
                            >
                              <span class="font-weight-bold mr-2 mb-1"
                                >Institution Site:</span
                              >
                              {{ order.institutionSite.title }}
                            </div>
                            <div
                              class="ml-4"
                              style="display: flex"
                              v-if="order.priority"
                            >
                              <span class="font-weight-bold mr-2 mb-1"
                                >Priority:</span
                              >
                              {{ order.priority.title }}
                            </div>
                            <div
                              class="ml-4"
                              style="display: flex"
                              v-if="order.sampleID"
                            >
                              <span class="font-weight-bold mr-2 mb-1"
                                >Sample Id:</span
                              >
                              {{ order.sampleID }}
                            </div>
                            <div
                              class="ml-4"
                              style="display: flex"
                              v-if="order.priority"
                            >
                              <span class="font-weight-bold mr-2 mb-1"
                                >Ordered Date:</span
                              >
                              {{
                                order.createdDate | moment("YYYY-MM-DD hh:mm A")
                              }}
                            </div>

                            <div
                              class="ml-4"
                              style="display: flex"
                              v-if="order.creatorAccount"
                            >
                              <span class="font-weight-bold mr-2 mb-1"
                                >Ordered By:</span
                              >
                              {{ order.creatorAccount.firstName }}
                              {{ order.creatorAccount.lastName }}
                            </div>
                          </v-card>
                          <!-- <v-card>
                                  <v-card-title>
                                    Collection Protocol</v-card-title
                                  >
                                </v-card> -->
                        </div>
                        <!-- <v-data-table
                            :headers="headers"
                            :items="columns"
                            :search="search"
                          ></v-data-table> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="db-TwoColumnLayout--rightColumn Box-root"
          style="flex-grow: 1"
        >
          <div class="Box-root Padding-top--24 Padding-bottom--48">
            <div class="StatefulPpanelsTabs--section" style="display: initial">
              <div class="Box-root">
                <div>
                  <v-card
                    elevation="0"
                    class="mt-2 pl-4 pb-3 pt-3"
                    v-if="false"
                  >
                    <div style="display: flex">
                      <!-- <div
                        class="ml-4"
                        style="display: flex"
                        v-if="order.institutionSite"
                      >
                        <span class="font-weight-bold mr-2 mb-1"
                          >Institution Site:</span
                        >
                        {{ order.institutionSite.title }}
                      </div>
                      <div
                        class="ml-4"
                        style="display: flex"
                        v-if="order.priority"
                      >
                        <span class="font-weight-bold mr-2 mb-1"
                          >Priority:</span
                        >
                        {{ order.priority.title }}
                      </div> -->
                      <v-spacer />
                      <v-btn
                        style="margin-right: 10px"
                        color="primary"
                        depressed
                        @click="saveTestResults()"
                        small
                        >Save</v-btn
                      >
                      <!-- print -->
                      <v-btn
                        style="margin-right: 10px"
                        color="primary"
                        depressed
                        @click="print()"
                        small
                        >Print</v-btn
                      >
                      <!-- <div class="ml-4" style="display: flex">
                          <span class="font-weight-bold mr-2 mb-1"
                            >Ordered By:</span
                          >
                          {{ order.orderedBy }}
                        </div> -->
                    </div>
                  </v-card>
                  <!-- {{ order.orderedPanels }} -->
                  <div class="d-flex">
                    <v-spacer />
                    <v-btn
                      class="mr-3"
                      color="primary"
                      depressed
                      icon
                      @click="printBarcode()"
                      small
                    >
                      <v-icon> mdi-barcode </v-icon>
                    </v-btn>
                    <v-btn
                      color="secondary"
                      depressed
                      small
                      @click="saveTestResults()"
                      >Save</v-btn
                    >
                    <v-btn
                      style="margin-right: 10px"
                      color="primary"
                      depressed
                      @click="print()"
                      small
                      >Print</v-btn
                    >
                  </div>
                  <v-snackbar v-model="snackbar" :timeout="timeout">
                    {{ text }}

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="blue"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                      >
                        Close
                      </v-btn>
                    </template>
                  </v-snackbar>
                  <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                      <v-card-title>
                        <span>Comment</span>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-textarea
                        style="padding: 15px"
                        outlined
                        v-model="testComment.comment"
                      ></v-textarea>
                      <v-card-actions>
                        <v-btn color="primary" text @click="dialog = false">
                          Close
                        </v-btn>
                        <v-btn
                          color="primary"
                          text
                          @click="saveTestResultComment()"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <div
                    class="flex flex-wrap justify-start items-start"
                    v-if="finalOrder ? finalOrder.orderedPanels : false"
                  >
                    <div
                      class="w-full max-w-xs flex flex-col border shadow rounded-lg mb-2"
                      v-for="(orderedPanel, index) in finalOrder.orderedPanels"
                      :key="index"
                    >
                      <!-- style="
                        min-width: 100px;
                        padding-bottom: 20px;
                        border: 1px solid #64b5f6;
                      " -->
                      <div
                        @contextmenu="show"
                        style="
                          min-height: 20px;
                          padding: 10px 15px;
                          font-weight: bold;
                        "
                        v-if="orderedPanel.panel"
                        @click="print(orderedPanel)"
                        class="border-b border-neutral-500"
                      >
                        {{ orderedPanel.panel.title }}
                        <!-- [{{
                          orderedPanel.orderedTests
                        }}] -->
                      </div>
                      <!-- <hr style="margin: 0px; background: #64b5f6" /> -->

                      <div
                        v-for="(
                          orderedTest, index
                        ) in orderedPanel.orderedTests"
                        :key="index"
                        class="border-b border-neutral-500"
                      >
                        <!-- <v-menu
                          v-model="showMenu"
                          :position-x="x"
                          :position-y="y"
                          absolute
                          offset-y
                        >
                          <v-list>
                            <v-list-item
                              @click="releaseTest(orderedPanel, orderedTest)"
                            >
                              Release
                            </v-list-item>
                            <v-list-item> Comment </v-list-item>
                          </v-list>
                        </v-menu> -->
                        <!-- <hr style="margin: 0px" /> -->
                        <!-- {{ orderedTest?. }} -->
                        <panel-test-row
                          :commentTest="commentTest"
                          :orderedPanel="orderedPanel"
                          :releaseTest="releaseTest"
                          v-if="orderedTest.testResult"
                          :orderedTest="orderedTest"
                        ></panel-test-row>

                        <!-- <div
                          v-if="orderedTest.testResult"
                          @contextmenu="show"
                          style="
                            min-height: 40px;
                            height: 40px;
                            display: flex;
                            margin-top: 10px;
                          "
                        >
                          <div
                            style="
                              height: 40px;
                              width: 30%;
                              text-align: center;
                              vertical-align: middle;
                              line-height: 40px;
                            "
                          >
                            {{ orderedTest.test.title }}
                          </div>
                          <div
                            style="
                              min-height: 40px;
                              min-width: 25%;
                              text-align: center;
                              vertical-align: middle;
                              line-height: 40px;
                            "
                          >
                            <span v-if="orderedTest.testAcceptedValues">
                              <v-select
                                v-if="orderedTest.testAcceptedValues.length > 0"
                                style="width: 100px"
                                dense
                                :items="orderedTest.testAcceptedValues"
                                item-text="title"
                                filled
                                v-model="orderedTest.testResult.result"
                                :rules="[(v) => !!v || '*Required']"
                              ></v-select>
                              <v-text-field
                                style="width: 100px"
                                v-else
                                :disabled="
                                  orderedTest.testResultRelease
                                    ? orderedTest.testResultRelease.isReleased
                                    : false
                                "
                                v-model="orderedTest.testResult.result"
                                dense
                                filled
                              ></v-text-field>
                            </span>
                          </div>
                          <div
                            style="
                              min-height: 40px;
                              width: 45%;
                              text-align: center;
                              vertical-align: middle;
                              line-height: 40px;
                            "
                          >
                            <span v-if="orderedTest.testResultRange">
                              <span
                                >{{ orderedTest.testResultRange.minimumValue }}
                                -
                                {{
                                  orderedTest.testResultRange.maximumValue
                                }}</span
                              >
                            </span>
                            <span v-if="orderedTest.test">
                              <span v-if="orderedTest.test.unitOfMeasurement"
                                >{{ test.unitOfMeasurement.unitSymbol }}
                              </span>
                            </span>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="StatefulPpanelsTabs--section"
              style="display: none"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="w-full h-full flex justify-center items-center p-40">
      <!-- {{ isLoading }} -->
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import apiClient from "../../API/apiClient";
import axiosClient from "../../API/api";
import VueContext from "vue-context";
import PanelTestRow from "../../components/CustomComponents/PanelTestRow.vue";
import axios from "axios";
export default {
  name: "order-test-result",
  components: {
    VueContext,
    PanelTestRow,
  },
  created() {
    this.getGenders();
    this.getVitalStatuses();
    this.getMaritalStatuses();
    this.getInstitutionSites();
    this.SampleId = this.$route.query.sampleId;
    console.log(this.$route.query.sampleId);
    this.searchOrder();
  },
  data() {
    return {
      snackbar: false,
      text: "Saved successfuly!",
      timeout: 2000,
      dialog: false,
      showMenu: false,
      x: 0,
      y: 0,
      items: [
        {
          title: "Release",
        },
        {
          title: "Comment",
        },
      ],
      testComment: { comment: "", orderedPanel: null, orderedTest: null },
      SampleId: "",
      orderedPanels: [],
      order: null,
      finalOrder: null,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      headers: [
        {
          text: "Sample Id",
          value: "sampleId",
        },
        { text: "Panels", value: "panels" },
      ],
      columns: [
        {
          sampleId: "ADF1000",
          panels: "PAN1, PAN2, PAN3,",
        },
        {
          sampleId: "GLU1000",
          panels: "PAN4, PAN5, PAN6,",
        },
      ],
      isLoading: false,
    };
  },
  methods: {
    ...mapActions([
      "getGenders",
      "getVitalStatuses",
      "getMaritalStatuses",
      "getInstitutionSites",
    ]),
    printBarcode() {
      var ipAddress = localStorage.getItem("barcodePrinterIP");
      var date = this.order.createdDate;
      var name =
        this.order.patient.firstName + " " + this.order.patient.fatherName;
      var mrn = "";
      if (this.order.PatientMRNs) {
        if (this.order.PatientMRNs.length > 0) {
          mrn = this.order.PatientMRNs[0].mrn;
        }
      }
      window.postMessage(
        {
          type: "zebra_print_label",
          zpl: `^XA
      ^FX Second section with recipient address and permit information.
      ^CFA,20
      ^FO10,20^AQN^FD${this.order.sampleID}^FS
      ^FO265,20^AQN^FD${date}^FS

      ^FX Third section with bar code.
      ^BY2,2,70
      ^FO10,45^BC,N,N,N,N^FD${this.order.sampleID}^FS

      ^CFA,20
      ^FO10,125^AQN^FDMRN:${mrn}^FS
      ^FO145,125^AQN^FD${name}^FS

      ^XZ`,
          url: "http://" + ipAddress + "/pstprnt",
        },
        "*"
      );
    },
    searchOrder() {
      // console.log(this.SampleId);
      this.isLoading = true;
      axiosClient.axiosClient
        .get(
          "institutions/" +
            this.currentInstitution.id +
            "/LIMSOrders?SampleID=" +
            this.SampleId
        )
        .then((response) => {
          console.log("search", response);
          let LIMSOrdersRes = response.data;
          apiClient
            .call(
              "GET",
              "institutions/" +
                this.currentInstitution.id +
                "/patients/" +
                LIMSOrdersRes[0].patientID +
                "/patientMRNs",
              null
              // patients%E2%80%8B/a274052a-9e22-4ca8-baf8-08d99c5355ea%E2%80%8B/patientMRNs
            )
            .then((patientMRNs) => {
              console.log("PatientMRNs", patientMRNs);
              this.$set(LIMSOrdersRes[0], "PatientMRNs", patientMRNs);
              // response[0].patient.PatientMRNs = response;
            })
            .catch((err) => console.log(err));
          if (LIMSOrdersRes.length == 0) {
            console.log("no response");
            this.order = null;
            return;
          }
          // console.log(response);
          // console.log("genders", this.genders[0]);
          this.genders.forEach((element) => {
            if (LIMSOrdersRes[0].patient.genderID == element.id) {
              LIMSOrdersRes[0].patient.gender = element;
            }
          });
          // this.genders.forEach((gender) => {
          //   console.log("gender", this.gender);
          //   if (response[0].patient.genderID == gender.id) {
          //     this.response[0].patient.gender = gender;
          //   }
          // });
          this.vitalStatuses.forEach((vitalStatus) => {
            if (LIMSOrdersRes[0].patient.vitalStatusID == vitalStatus.id) {
              LIMSOrdersRes[0].patient.vitalStatus = vitalStatus;
            }
          });
          this.maritalStatuses.forEach((maritalStatus) => {
            if (LIMSOrdersRes[0].patient.maritalStatusID == maritalStatus.id) {
              LIMSOrdersRes[0].patient.maritalStatus = maritalStatus;
            }
          });
          // console.log("institutionSites", this.institutionSites);
          this.institutionSites.forEach((institutionSite) => {
            if (LIMSOrdersRes[0].institutionSiteID == institutionSite.id) {
              LIMSOrdersRes[0].institutionSite = institutionSite;
            }
          });
          var order = LIMSOrdersRes[0];
          axiosClient.axiosClient
            .get(
              // "GET",
              "institutions/" +
                this.currentInstitution.id +
                "/LIMSOrders/" +
                order?.id +
                "/limsOrderedPanels?PageSize=5000"
              // null
            )
            .then((orderedPanelsRes) => {
              let orderedPanels = orderedPanelsRes.data;
              orderedPanels.forEach((orderedPanel) => {
                axiosClient.axiosClient
                  .get(
                    "institutions/" +
                      this.currentInstitution.id +
                      "/LIMSOrders/" +
                      order?.id +
                      "/limsOrderedPanels/" +
                      orderedPanel.id +
                      "/limsOrderedTests?PageSize=5000"
                    // null
                  )
                  .then((orderedTestsRes) => {
                    let orderedTests = orderedTestsRes.data;
                    // orderedTests.forEach((orderedTest) => {
                    //   axiosClient.axiosClient
                    //     .get(
                    //       "institutions/" +
                    //         this.currentInstitution.id +
                    //         "/tests/" +
                    //         orderedTest.test.id +
                    //         "/testAcceptedValues"
                    //       // null
                    //     )
                    //     .then((testAcceptedValuesRes) => {
                    //       let testAcceptedValues = testAcceptedValuesRes.data;
                    //       // console.log("testAcceptedValues", testAcceptedValues);
                    //       this.$set(
                    //         orderedTest,
                    //         "testAcceptedValues",
                    //         testAcceptedValues
                    //       );
                    //     })
                    //     .catch((err) => console.log(err));

                    //   // this.getTestResultsByTestId(orderedTest.test.id);
                    //   axiosClient.axiosClient
                    //     .get(
                    //       "institutions/" +
                    //         this.currentInstitution.id +
                    //         "/LIMSOrders/" +
                    //         order.id +
                    //         "/limsOrderedPanels/" +
                    //         orderedPanel.id +
                    //         "/limsOrderedTests/" +
                    //         orderedTest.id +
                    //         "/limsOrderedTestResults"
                    //       // null
                    //     )
                    //     .then((testResultsRes) => {
                    //       let testResults = testResultsRes.data;
                    //       testResults.forEach((tr) => {
                    //         tr.previousResult = tr.result;
                    //       });
                    //       // console.log("testResults", testResults[0]);
                    //       this.$set(orderedTest, "testResult", testResults[0]);
                    //       if (testResults[0].testResultRangeID) {
                    //         axiosClient.axiosClient
                    //           .get(
                    //             "institutions/" +
                    //               this.currentInstitution.id +
                    //               "/tests/" +
                    //               orderedTest.test.id +
                    //               "/testResultRanges/" +
                    //               testResults[0].testResultRangeID
                    //             // null
                    //           )
                    //           .then((testResultRangeRes) => {
                    //             let testResultRange = testResultRangeRes.data;
                    //             // console.log("testResultRange", testResultRange);
                    //             this.$set(
                    //               orderedTest,
                    //               "testResultRange",
                    //               testResultRange
                    //             );
                    //           })
                    //           .catch((err) => console.log(err));
                    //       }

                    //       if (testResults[0]) {
                    //         axiosClient.axiosClient
                    //           .get(
                    //             // "GET",
                    //             `institutions/${this.currentInstitution.id}/LIMSOrders/${order.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${testResults[0].id}/limsOrderedTestResultReleases`
                    //             // null
                    //           )
                    //           .then((testResultReleaseRes) => {
                    //             let testResultRelease =
                    //               testResultReleaseRes.data;
                    //             console.log(
                    //               "test result releases ======================",
                    //               testResultRelease
                    //             );
                    //             // console.log(
                    //             //   "testResultRelease",
                    //             //   testResultRelease[0]
                    //             // );
                    //             this.$set(
                    //               orderedTest,
                    //               "testResultRelease",
                    //               testResultRelease[0]
                    //             );
                    //           })
                    //           .catch((err) => console.log(err));
                    //       }
                    //     })
                    //     .catch((err) => console.log(err));
                    // });

                    let promises = [];
                    let testAcceptedValues = [];
                    let testResults = [];
                    let testResultRanges = [];
                    let testResultReleases = [];

                    orderedTests.forEach((orderedTest) => {
                      promises.push(
                        axiosClient.axiosClient
                          .get(
                            "institutions/" +
                              this.currentInstitution.id +
                              "/tests/" +
                              orderedTest.test.id +
                              "/testAcceptedValues"
                            // null
                          )
                          .then((response) => {
                            // console.log("testAcceptedValues", response);
                            testAcceptedValues.push(...response.data);
                            return Promise.resolve();
                          })
                          .catch((err) => {
                            console.log(err);
                            return Promise.reject(err);
                          })
                      );

                      promises.push(
                        axiosClient.axiosClient
                          .get(
                            "institutions/" +
                              this.currentInstitution.id +
                              "/LIMSOrders/" +
                              order.id +
                              "/limsOrderedPanels/" +
                              orderedPanel.id +
                              "/limsOrderedTests/" +
                              orderedTest.id +
                              "/limsOrderedTestResults"
                            // null
                          )
                          .then((response) => {
                            console.log(
                              "testResults response: ",
                              response.data
                            );
                            // testResults.push(response);
                            // return Promise.resolve();
                            // testResultRelease and testResultRange
                            let testResultPromises = [];

                            response.data.forEach((testResult) => {
                              testResultPromises.push(
                                axiosClient.axiosClient
                                  .get(
                                    `institutions/${this.currentInstitution.id}/LIMSOrders/${order.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${testResult.id}/limsOrderedTestResultReleases`
                                    // null
                                  )
                                  .then((testResultRelease) => {
                                    console.log(
                                      "testResultRelease ||||||| ;;;;;;;;",
                                      testResultRelease.data
                                    );
                                    // this.$set(testResult, "testResultRelease", testResultRelease[0]);
                                    testResultReleases.push(
                                      ...testResultRelease.data
                                    );
                                    return Promise.resolve();
                                  })
                                  .catch((err) => {
                                    console.log(err);
                                    return Promise.reject(err);
                                  })
                              );

                              if (testResult.testResultRangeID) {
                                testResultPromises.push(
                                  axiosClient.axiosClient
                                    .get(
                                      `institutions/${this.currentInstitution.id}/tests/${orderedTest.test.id}/testResultRanges/${testResult.testResultRangeID}`
                                      // null
                                    )
                                    .then((testResultRange) => {
                                      testResultRanges.push(
                                        ...testResultRange.data
                                      );
                                    })
                                    .catch((err) => console.log(err))
                                );
                              }
                              testResults.push({
                                ...testResult,
                                previousResult: testResult.result,
                              });
                            });

                            return Promise.all(testResultPromises);
                          })
                          .catch((err) => {
                            console.log(err);
                            return Promise.reject(err);
                          })
                      );
                    });

                    Promise.all(promises)
                      .then(() => {
                        console.log(">>>>> DONE!");
                        console.log(
                          "[[[testAcceptedValues]]]",
                          testAcceptedValues
                        );
                        console.log("[[[testResults]]]", testResults);
                        console.log("[[[testResultRanges]]]", testResultRanges);
                        console.log(
                          "[[[testResultReleases]]]",
                          testResultReleases
                        );

                        let finalOrder = {
                          ...order,
                          orderedPanels: orderedPanels.map((panel) => {
                            return {
                              ...panel,
                              orderedTests: panel.orderedTests.map(
                                (orderedTest) => {
                                  // console.log("test", test);
                                  const acceptedValues =
                                    testAcceptedValues.filter(
                                      (value) =>
                                        value.testID === orderedTest.test.id
                                    );
                                  const result = testResults.find(
                                    (result) =>
                                      result.limsOrderedTestID ===
                                      orderedTest.id
                                  );

                                  console.log(
                                    " > > testResults < <",
                                    testResults,
                                    result
                                  );
                                  console.log(
                                    " >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>"
                                  );

                                  const range = testResultRanges.find(
                                    (range) =>
                                      range.id === result?.testResultRangeID
                                  );
                                  const release = testResultReleases.find(
                                    (release) =>
                                      release.limsOrderedTestResultID ===
                                      result?.id
                                  );

                                  return {
                                    ...orderedTest,
                                    testAcceptedValues: acceptedValues,
                                    testResult: result,
                                    testResultRange: range,
                                    testResultRelease: release,
                                  };
                                }
                              ),
                            };
                          }),
                        };

                        this.finalOrder = finalOrder;
                        this.isLoading = true;

                        console.log("[[:order:]]", finalOrder);
                      })
                      .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                      });

                    this.$set(orderedPanel, "orderedTests", orderedTests);
                    // orderedPanel.orderedTests = orderedTests;
                  })
                  .catch((err) => {
                    console.log(err);
                    this.isLoading = false;
                  });
              });
              // console.log("orderedPanels", orderedPanels);
              // this.orderedPanels = orderedPanels;
              this.$set(order, "orderedPanels", orderedPanels);
            })
            .catch((err) => {
              console.log(err);
              this.isLoading = false;
            });
          this.order = order;
          // console.log("order", order);
        })
        .catch((err) => console.log(err));
    },
    escapeHtml(value) {
      if (value === null || value === undefined) return "";
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    formatDateTime(value) {
      if (!value) return "";
      var d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      var pad = (n) => String(n).padStart(2, "0");
      var hours = d.getHours();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(hours) +
        ":" +
        pad(d.getMinutes()) +
        " " +
        ampm
      );
    },
    patientAge(birthDate) {
      if (!birthDate) return "";
      var b = new Date(birthDate);
      if (isNaN(b.getTime())) return "";
      var now = new Date();
      var years = now.getFullYear() - b.getFullYear();
      var m = now.getMonth() - b.getMonth();
      if (m < 0 || (m === 0 && now.getDate() < b.getDate())) years--;
      if (years > 0) return years + " yr";
      var months = years * 12 + m;
      if (months < 0) months = 0;
      return months + " mo";
    },
    // Returns "H" / "L" / "" for a numeric result against its reference range.
    resultFlag(orderedTest) {
      var range = orderedTest.testResultRange;
      var raw = orderedTest.testResult ? orderedTest.testResult.result : null;
      if (!range || raw === null || raw === undefined || raw === "") return "";
      var value = Number(raw);
      if (isNaN(value)) return "";
      var min = Number(range.minimumValue);
      var max = Number(range.maximumValue);
      if (!isNaN(min) && value < min) return "L";
      if (!isNaN(max) && value > max) return "H";
      return "";
    },
    referenceRangeText(orderedTest) {
      var range = orderedTest.testResultRange;
      if (!range) return "";
      var min = range.minimumValue;
      var max = range.maximumValue;
      if (min === null || min === undefined || min === "") {
        return max === null || max === undefined || max === "" ? "" : "< " + max;
      }
      if (max === null || max === undefined || max === "") return "> " + min;
      return min + " - " + max;
    },
    accountName(account) {
      if (!account) return "";
      return (
        [account.firstName, account.lastName].filter(Boolean).join(" ") ||
        account.userName ||
        ""
      );
    },
    unitText(orderedTest) {
      var test = orderedTest.test;
      if (!test || !test.unitOfMeasurement) return "";
      return (
        test.unitOfMeasurement.unitSymbol ||
        test.unitOfMeasurement.title ||
        ""
      );
    },
    // arg: an orderedPanel prints just that panel; null prints the whole order.
    print(arg = null) {
      var order = this.finalOrder || this.order;
      if (!order) return;

      var panels = order.orderedPanels || [];
      if (arg && arg.id) {
        panels = panels.filter((p) => p.id === arg.id);
      }
      if (panels.length === 0) {
        this.text = "Nothing to print.";
        this.snackbar = true;
        return;
      }

      var esc = this.escapeHtml;
      var patient = order.patient || {};
      var mrn =
        order.PatientMRNs && order.PatientMRNs.length > 0
          ? order.PatientMRNs.map((m) => m.mrn).join(", ")
          : "";
      var institution = this.currentInstitution || {};
      var patientName = [
        patient.firstName,
        patient.fatherName,
        patient.grandFatherName,
      ]
        .filter(Boolean)
        .join(" ");

      var infoRow = (label, value) =>
        value
          ? `<div class="info-item"><span class="info-label">${esc(
              label
            )}</span><span class="info-value">${esc(value)}</span></div>`
          : "";

      // Performed by = whoever entered the result (testResult.enablerAccount).
      // Verified by  = whoever released it (testResultRelease.releasorAccount).
      var performers = {};
      var verifiers = {};
      panels.forEach((panel) => {
        (panel.orderedTests || []).forEach((orderedTest) => {
          if (!orderedTest.testResult) return;
          var performer = this.accountName(
            orderedTest.testResult.enablerAccount
          );
          if (performer) {
            var pDate = orderedTest.testResult.enabledDate;
            if (!performers[performer] || pDate > performers[performer]) {
              performers[performer] = pDate;
            }
          }
          var release = orderedTest.testResultRelease;
          if (release && release.isReleased) {
            var verifier = this.accountName(release.releasorAccount);
            if (verifier) {
              var vDate = release.releasedDate;
              if (!verifiers[verifier] || vDate > verifiers[verifier]) {
                verifiers[verifier] = vDate;
              }
            }
          }
        });
      });

      var signatureBlock = (label, map) => {
        var names = Object.keys(map);
        var body = names.length
          ? names
              .map(
                (name) =>
                  `<div class="sig-name">${esc(name)}</div>
                   <div class="sig-date">${esc(
                     this.formatDateTime(map[name])
                   )}</div>`
              )
              .join("")
          : `<div class="sig-name">&nbsp;</div><div class="sig-date">&nbsp;</div>`;
        return `<div class="sig-block">
          ${body}
          <div class="sig-label">${esc(label)}</div>
        </div>`;
      };

      var panelsHtml = panels
        .map((panel) => {
          var rows = (panel.orderedTests || [])
            .filter((t) => t.testResult)
            .map((orderedTest) => {
              var flag = this.resultFlag(orderedTest);
              var released = orderedTest.testResultRelease
                ? orderedTest.testResultRelease.isReleased
                : false;
              return `<tr>
                <td class="test-name">${esc(
                  orderedTest.test ? orderedTest.test.title : ""
                )}</td>
                <td class="result ${flag ? "abnormal" : ""}">${esc(
                orderedTest.testResult.result
              )}</td>
                <td class="flag ${flag ? "abnormal" : ""}">${esc(flag)}</td>
                <td>${esc(this.unitText(orderedTest))}</td>
                <td>${esc(this.referenceRangeText(orderedTest))}</td>
                <td>${released ? "Final" : "Preliminary"}</td>
              </tr>${
                orderedTest.comment
                  ? `<tr class="comment-row"><td colspan="6">Comment: ${esc(
                      orderedTest.comment
                    )}</td></tr>`
                  : ""
              }`;
            })
            .join("");

          if (!rows) return "";

          return `<section class="panel">
            <h2>${esc(panel.panel ? panel.panel.title : "Results")}</h2>
            <table>
              <thead>
                <tr>
                  <th style="width:32%">Test</th>
                  <th style="width:14%">Result</th>
                  <th style="width:6%">Flag</th>
                  <th style="width:12%">Unit</th>
                  <th style="width:22%">Reference Range</th>
                  <th style="width:14%">Status</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
          </section>`;
        })
        .join("");

      if (!panelsHtml) {
        this.text = "No results available to print.";
        this.snackbar = true;
        return;
      }

      var html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>Laboratory Report - ${esc(order.sampleID || "")}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: "Segoe UI", Arial, sans-serif; color: #000; font-size: 12px; margin: 24px; }
  header { border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 12px; }
  header .inst { font-size: 18px; font-weight: 700; text-transform: uppercase; }
  header .sub { font-size: 11px; }
  header .doc-title { margin-top: 6px; font-size: 14px; font-weight: 700; letter-spacing: 1px; text-align: center; text-transform: uppercase; }
  .info { display: flex; flex-wrap: wrap; border: 1px solid #000; padding: 6px 8px; margin-bottom: 14px; }
  .info-item { width: 33.33%; padding: 2px 4px; display: flex; gap: 4px; }
  .info-label { font-weight: 700; }
  .info-label::after { content: ":"; }
  .panel { margin-bottom: 16px; page-break-inside: avoid; }
  .panel h2 { font-size: 12px; text-transform: uppercase; margin: 0 0 4px; padding: 4px 6px; background: #eee; border: 1px solid #000; }
  table { width: 100%; border-collapse: collapse; }
  th, td { border: 1px solid #000; padding: 4px 6px; text-align: left; vertical-align: top; }
  th { background: #f5f5f5; font-size: 11px; text-transform: uppercase; }
  td.result { font-weight: 700; }
  td.abnormal { font-weight: 700; }
  td.flag { text-align: center; }
  .comment-row td { font-style: italic; font-size: 11px; background: #fafafa; }
  .signature { margin-top: 36px; display: flex; justify-content: space-between; page-break-inside: avoid; }
  .sig-block { width: 45%; }
  .sig-name { font-weight: 700; min-height: 14px; }
  .sig-date { font-size: 10px; min-height: 12px; margin-bottom: 2px; }
  .sig-label { border-top: 1px solid #000; padding-top: 4px; font-size: 11px; text-transform: uppercase; }
  footer { margin-top: 18px; border-top: 1px solid #000; padding-top: 6px; font-size: 10px; text-align: center; }
  @media print { body { margin: 12mm; } }
</style>
</head>
<body>
  <header>
    <div class="inst">${esc(
      institution.title || institution.name || "Laboratory"
    )}</div>
    <div class="sub">${esc(
      order.institutionSite ? order.institutionSite.title : ""
    )}</div>
    <div class="doc-title">Laboratory Test Report</div>
  </header>

  <div class="info">
    ${infoRow("Patient", patientName)}
    ${infoRow("MRN", mrn)}
    ${infoRow("Sample ID", order.sampleID)}
    ${infoRow("Gender", patient.gender ? patient.gender.title : "")}
    ${infoRow("Age", this.patientAge(patient.birthDate))}
    ${infoRow("Priority", order.priority ? order.priority.title : "")}
    ${infoRow("Ordered Date", this.formatDateTime(order.createdDate))}
    ${infoRow(
      "Ordered By",
      order.creatorAccount
        ? [order.creatorAccount.firstName, order.creatorAccount.lastName]
            .filter(Boolean)
            .join(" ")
        : ""
    )}
    ${infoRow("Printed", this.formatDateTime(new Date()))}
  </div>

  ${panelsHtml}

  <div class="signature">
    ${signatureBlock("Performed By", performers)}
    ${signatureBlock("Verified By", verifiers)}
  </div>

  <footer>
    Results marked "Preliminary" have not been released and are not for clinical use.
    H = above reference range, L = below reference range.
  </footer>
</body>
</html>`;

      var printWindow = window.open("", "_blank", "width=900,height=700");
      if (!printWindow) {
        this.text = "Please allow pop-ups to print the result.";
        this.snackbar = true;
        return;
      }
      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      printWindow.focus();
      // Give the new document a tick to lay out before invoking print.
      setTimeout(() => {
        printWindow.print();
      }, 300);
    },
    saveTestResults() {
      if (this.finalOrder.orderedPanels) {
        console.log(
          "this.finalOrder.orderedPanels",
          this.finalOrder.orderedPanels.length
        );
        for (const index in this.finalOrder.orderedPanels) {
          var orderedPanel = this.finalOrder.orderedPanels[index];
          // console.log("orderedPanel", orderedPanel);
          // console.log(orderedPanel.orderedTests);
          for (const index in orderedPanel.orderedTests) {
            var orderedTest = orderedPanel.orderedTests[index];
            // console.log("orderedTest", orderedTest);
            if (
              orderedTest.testResult.result !=
              orderedTest.testResult.previousResult
            ) {
              console.log(
                orderedTest.test.title + " changed",
                orderedTest.testResult.previousResult,
                orderedTest.testResult.result
              );
              var updatedTestResult = {
                result: orderedTest.testResult.result,
                // testResultRangeID: orderedTest.testResult.testResultRangeID,
              };
              console.log(
                `institutions/${this.currentInstitution.id}/LIMSOrders/${this.finalOrder.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${orderedTest.testResult.id}`
              );
              apiClient
                .call(
                  "PUT",
                  `institutions/${this.currentInstitution.id}/LIMSOrders/${this.finalOrder.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${orderedTest.testResult.id}`,
                  updatedTestResult
                )
                .then((response) => {
                  console.log("saved: ", response);
                  this.snackbar = true;
                })
                .catch((err) => console.log(err));
            }
          }
          // orderedPanel.panel.orderedTests.forEach((orderedTest) => {

          // });
        }
      }
    },
    releaseTest(orderedPanel, orderedTest) {
      // console.log("releaseTest", orderedPanel, orderedTest);
      this.saveTestResults();
      console.log("releasing: ", orderedPanel, orderedTest);
      var newTestResultRelease = {
        id: orderedTest.testResultRelease.id,
        limsOrderedTestResultID: orderedTest.testResult.id,
      };
      console.log(
        `institutions/${this.currentInstitution.id}/LIMSOrders/${this.finalOrder.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${orderedTest.testResult.id}/limsOrderedTestResultReleases/${orderedTest.testResultRelease.id}/release`
      );
      apiClient
        .call(
          "POST",
          `institutions/${this.currentInstitution.id}/LIMSOrders/${this.finalOrder.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${orderedTest.testResult.id}/limsOrderedTestResultReleases/${orderedTest.testResultRelease.id}/release`,
          newTestResultRelease
        )
        .then((response) => {
          console.log("released: ", orderedTest.test.title);
          this.searchOrder();
        })
        .catch((err) => console.log(err));
    },
    releasePanel(orderedPanel) {
      orderedPanel.orderedTests.forEach((orderedTest) => {
        console.log("releasing: ", orderedPanel, orderedTest);
        var newTestResultRelease = {
          isReleased: true,
          releasedDate: Date.now(),
          id: orderedTest.testResultRelease.id,
          limsOrderedTestResultID: orderedTest.testResult.id,
        };
        apiClient
          .call(
            "POST",
            `institutions/${this.currentInstitution.id}/LIMSOrders/${this.finalOrder.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}/limsOrderedTestResults/${orderedTest.testResult.id}/limsOrderedTestResultReleases/${orderedTest.testResultRelease.id}/release`,
            newTestResultRelease
          )
          .then((response) => {
            console.log("saved: ", response);
          })
          .catch((err) => console.log(err));
      });
    },
    commentTest(orderedPanel, orderedTest) {
      this.testComment.comment = orderedTest.comment;
      this.testComment.orderedPanel = orderedPanel;
      this.testComment.orderedTest = orderedTest;
      this.dialog = true;
    },
    saveTestResultComment() {
      console.log("Save comment", this.testComment);
      this.finalOrder.orderedPanels.forEach((orderedPanel) => {
        if (orderedPanel.id == this.testComment.orderedPanel.id) {
          orderedPanel.orderedTests.forEach((orderedTest) => {
            if (orderedTest.id == this.testComment.orderedTest.id) {
              this.$set(orderedTest, "comment", this.testComment.comment);
              apiClient
                .call(
                  "PUT",
                  `institutions/${this.currentInstitution.id}/LIMSOrders/${this.finalOrder.id}/limsOrderedPanels/${orderedPanel.id}/limsOrderedTests/${orderedTest.id}`,
                  orderedTest
                )
                .then((response) => {
                  console.log("commented: ", response);
                })
                .catch((err) => console.log(err));
              // console.log("Comment on this one!", orderedTest.test.title);
            }
          });
        }
      });
      this.dialog = false;
    },
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
  },
  computed: {
    ...mapGetters([
      "currentInstitution",
      "genders",
      "vitalStatuses",
      "maritalStatuses",
      "institutionSites",
    ]),
  },
};
</script>
<style>
.v-card__subtitle,
.v-card__text {
  font-size: unset !important;
}
</style>
